import "./cases.css";


import c1 from "./img/mini-case6.jpg";
import c2 from "./img/mini-case3.jpg";
import c3 from "./img/mini-case4.jpg";

function CasesBrend() {
	return (
    <div className="cases__container">
      <h4 className="cases__title">Кейсы</h4>
      <div className="cases__grid">
        <a href="/sharx-design-system" target="_blank" className="cases__item">
          <img
            src={c1}
            alt="Масштабируемая программно-аппаратная платформа виртуализации"
          />
        </a>

        <a
          href="https://www.behance.net/gallery/214171801/GoChinChin-Meeting-Mobile-App"
          target="_blank"
          className="cases__item"
        >
          <img
            src={c3}
            alt="GoChinChin это приложение по поиску встреч и общения с единомышленниками в комфортной и непринужденной атмосфере."
          />
        </a>
        <a
          href="https://equilibrium.io/"
          target="_blank"
          className="cases__item"
        >
          <img
            src={c2}
            alt="All-in-one DeFi hub of Polkadot. High leverage. Yet resilient"
          />
        </a>
      </div>
    </div>
  );
}

export default CasesBrend;
